var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoNowIndicator = function SvgIcoNowIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    fill: "none",
    viewBox: "0 0 12 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F33",
    fillRule: "evenodd",
    d: "M11.633 6.36A1 1 0 0 1 10.865 8h-9.73a1 1 0 0 1-.768-1.64L5.232.522a1 1 0 0 1 1.536 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoNowIndicator;